// CONSTANTS are all caps.
const NS = 'ReviewForm';
const CLS = 'reviewForm';
const WG = '.' + CLS + '-';
const $loadingSpinner = $('.loading-spinner');
const CLS_ACTIVE = 'is-active';
const CLS_DISABLED = 'disabled';
const CLS_HIDE = 'd-none';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/reviewForm.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

import * as utils from '../../../../global/js/utils';
import * as Api from '../../../../global/js/api';

export class ReviewForm {
	constructor($el) {
		// $el is the widget node return by the loadReviewForm function
		this.$el = $el;
	}

	init() {
		this.initFormValidationConstraints();
	}

	initFormValidationConstraints() {
		const This = this;
		let $form = $(this.$el).find('form')[0];
		utils.formValidation($form, This);
	}

	formSuccessCallback(form) {
		this.submitForm();
	}

	submitForm() {
		const This = this;
		const $wg = $(this.$el);
		let $form = $wg.find('form');
		let $error = $wg.find(`${WG}error`);
		let $success = $wg.find(`${WG}success`);
		let $submitBtn = $wg.find(`${WG}submitBtn`);

		$loadingSpinner.addClass(CLS_ACTIVE);
		This.reset();

		This.submitCall().then(function(resp) {
			if (resp.result === 'SUCCESS') {
				if (resp.message) {
					$success.addClass(CLS_ACTIVE).html(resp.message);
				} else {
					$wg.modal('hide');
				}

				$submitBtn.attr('disabled', true).addClass(CLS_HIDE);

				$form.find('input, textarea').prop('disabled', true);

				let writeBtn = document.querySelector(`${WG}writeBtn`);
				if (writeBtn) {
					$(writeBtn)
						.addClass('has-added')
						.html('Pending moderation')
						.removeAttr('data-toggle');
				}
			} else {
				$error.addClass(CLS_ACTIVE).html(resp.message);
			}

			$wg.animate({scrollTop: 0}, 500);

			$loadingSpinner.removeClass(CLS_ACTIVE);
		})
		.catch(function(error) {
			$error.addClass(CLS_ACTIVE).html(error);
			$loadingSpinner.removeClass(CLS_ACTIVE);

			$wg.animate({scrollTop: 0}, 500);
		});
	}

	submitCall() {
		const $wg = $(this.$el);
		const $form = $wg.find('form');
		let endpoint = $wg.data('addReviewEndpoint');
		let fields = $form.serializeArray();
		let data = {};

		for (let key in fields) {
			// just putting an if here to remove lint errors
			if (fields) {
				let field = fields[key];
				data[field['name']] = field['value'] || '';
			}
		}

		data.productCode = $(document).find('[data-item-code]').data('itemCode') || '';

		if (!data.productCode || data.productCode == '') return Promise.reject('There was a problem submitting this review. Please try again later.');

		return Api.callApi(endpoint, data);
	}

	reset() {
		const $wg = $(this.$el);
		let $form = $wg.find('form');
		let $error = $wg.find(`${WG}error`);
		let $success = $wg.find(`${WG}success`);
		let $submitBtn = $wg.find(`${WG}submitBtn`);

		// $form.trigger('reset');
		$error.removeClass(CLS_ACTIVE).html('');
		$success.removeClass(CLS_ACTIVE).html('');
		$submitBtn.removeClass(CLS_HIDE).attr('disabled', false);
	}

	// Add more functions like on above here
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_06/_work/151/s/FrontEnd/src/views/widgets/reviewForm/js/reviewForm.js